import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { BaseDevice } from "./base-device";
import { Store } from "aurelia-store";
import * as State from "../../../store/state";
import { applicationLogger } from "../../../logging/logger";
import IState = State.IState;
import { AsEnumerable } from "linq-es2015/lib/linq";
import { Api } from "../../../services/api";
import { Device } from "../../../models/device";
import { DigitalOutputToggleRequestViewModel } from "../../../models/digital-output-toggle-request-view-model";
import { Curtain } from "./curtain-enum";
import { I18N } from "aurelia-i18n";
import { CurtainDirection } from "./curtain-direction";

@autoinject
export class CurtainController extends BaseDevice {
	i18n: I18N;
	disabled: boolean = false;

	private leftCurtainCss_: string;// = "left-curtain-middle";
	private rightCurtainCss_: string;// = "right-curtain-middle";

	delay: number = 35;
	constructor(store: Store<IState>, api: Api, i18n: I18N) {
		super(store, api);
		this.i18n = i18n;
	}

	public leftController: Device;
	public rightController: Device;

	activate(device: Device) {
		this.device = device;

		if (this.device.children.length > 0) {
			this.leftController = this.getController("left");
			this.rightController = this.getController("right");
		}
	}

	getController(position: string): Device {
		return this.device.children.find(
			child => child.deviceProperties.find(
				property => property.name === "position" && property.value === position));
		//const controller = AsEnumerable(this.device.children).FirstOrDefault(device => device.properties.position === position);
		//return controller as Device;
	}

	unbind() {
		this.unsubscribe();
	}

	attached() {

	}

	toggleCss(direction: string, mode: Curtain) {

		switch (mode) {
			case Curtain.Left:
				switch (direction) {
					case "up":
						{
							this.leftCurtainCss = "left-curtain-top";
							break;
						}
					case "down":
						{
							this.leftCurtainCss = "left-curtain-bottom";
							break;

						}
				}
				break;
			case Curtain.Right:
				switch (direction) {
					case "up":
						{
							this.rightCurtainCss = "right-curtain-top";
							break;
						}
					case "down":
						{
							this.rightCurtainCss = "right-curtain-bottom";
							break;

						}
				}
				break;
			case Curtain.Both:
				switch (direction) {
					case "up":
						{
							if (this.leftController.data.digitalInput2 === 0) {
								this.leftCurtainCss = "left-curtain-top";
							}
							if (this.rightController.data.digitalInput2 === 0) {
								this.rightCurtainCss = "right-curtain-top";
							}
							break;
						}
					case "down":
						{
							if (this.leftController.data.digitalInput1 === 0) {
								this.leftCurtainCss = "left-curtain-bottom";
							}
							if (this.rightController.data.digitalInput1 === 0) {
								this.rightCurtainCss = "right-curtain-bottom";
							}
							break;
						}
				}
				break;
		}

	}

	async toggleCurtains(viewModel: DigitalOutputToggleRequestViewModel, direction: string, mode: Curtain) {

		this.toggleCss(direction, mode);

		viewModel.message = direction === "up" ? CurtainDirection.up : CurtainDirection.down;
		const response = await this.api.toggleCurtain(viewModel);
		if (response.success) {
			this.disabled = true;
			setTimeout(() => {
				this.disabled = false;
			},
				this.delay * 1000);
		}
	}

	async toggleBoth(direction: string) {

		const viewModel = new DigitalOutputToggleRequestViewModel();
		switch (direction) {
			case "up":
				{
					if (this.leftController.data.digitalInput1 === 0) {
						viewModel.deviceIds.push(this.leftController.deviceId);
					}
					if (this.rightController.data.digitalInput1 === 0) {
						viewModel.deviceIds.push(this.rightController.deviceId);
					}
					break;
				}

			case "down":
				{
					if (this.leftController.data.digitalInput2 === 0) {
						viewModel.deviceIds.push(this.leftController.deviceId);
					}
					if (this.rightController.data.digitalInput2 === 0) {
						viewModel.deviceIds.push(this.rightController.deviceId);
					}
					break;
				}
		}
		await this.toggleCurtains(viewModel, direction, Curtain.Both);
	}


	async toggleLeft(direction: string) {
		const viewModel = new DigitalOutputToggleRequestViewModel();
		viewModel.deviceIds.push(this.leftController.deviceId);
		await this.toggleCurtains(viewModel, direction, Curtain.Left);
	}

	async toggleRight(direction: string) {
		const viewModel = new DigitalOutputToggleRequestViewModel();
		viewModel.deviceIds.push(this.rightController.deviceId);
		await this.toggleCurtains(viewModel, direction, Curtain.Right);
	}

	//@computedFrom('leftController.data')
	//get leftPositionCss(): string {
	//	if (this.leftController.data === undefined) {
	//		return null;
	//	}

	//	if (this.leftController.data.digitalInput1 === 1) {
	//		return "blue";
	//	}

	//	if (this.leftController.data.digitalOutput1 === 1) {
	//		return "red";
	//	}

	//	if (this.leftController.data.digitalInput2 === 1) {
	//		return "green";
	//	}

	//	if (this.leftController.data.digitalOutput2 === 1) {
	//		return "yellow";
	//	}

	//	return "";
	//}

	@computedFrom('leftController.data', 'rightController.data')
	get curtainMessage(): string {

		if (this.leftController === undefined || this.leftController.data === undefined || this.rightController === undefined || this.rightController.data === undefined) {
			return "";
		}

		applicationLogger.debug(`Left controller data: ${JSON.stringify(this.leftController.data)}`);
		applicationLogger.debug(`Right controller data: ${JSON.stringify(this.rightController.data)}`);

		if (this.leftController.data.digitalOutput2 === 0 && this.rightController.data.digitalOutput2 === 0) {
			if (this.leftController.data.digitalInput1 === 1 && this.rightController.data.digitalInput1 === 1) {
				return this.i18n.tr("opened");
			}

			if (this.leftController.data.digitalInput2 === 1 && this.rightController.data.digitalInput2 === 1) {
				return this.i18n.tr("closed");
			}

			if (this.leftController.data.digitalInput2 === 0 || this.rightController.data.digitalInput2 === 0) {
				return this.i18n.tr("partially-opened");
			}
		}

		if (this.leftController.data.digitalOutput1 === 1 || this.rightController.data.digitalOutput1 === 1) {
			return this.i18n.tr("opening");
		}

		if (this.leftController.data.digitalOutput2 === 1 || this.rightController.data.digitalOutput2 === 1) {
			return this.i18n.tr("closing");
		}

	

		//if (this.leftController.data.digitalInputput1 === 0 ||
		//	this.leftController.data.digitalOutput2 === 0 ||
		//	this.rightController.data.digitalInputput1 === 0 ||
		//	this.rightController.data.digitalOutput2 === 0) {
		//	return this.i18n.tr("partially-opened");
		//}

		return "";
	}

	@computedFrom('leftController.data')
	get leftCurtainCss() {
		//if (this.leftController && this.leftController.data && this.leftController.data.digitalInput1 && this.leftController.data.digitalInput2) {
		if (this.leftController && this.leftController.data) {
			if (this.leftController.data.digitalInput1 === 0 && this.leftController.data.digitalInput2 === 0) {
				this.leftCurtainCss = "left-curtain-middle";
			}

			if (this.leftController.data.digitalInput1 === 1 && this.leftController.data.digitalInput2 === 0) {
				this.leftCurtainCss = "left-curtain-top";
			}

			if (this.leftController.data.digitalInput1 === 0 && this.leftController.data.digitalInput2 === 1) {
				this.leftCurtainCss = "left-curtain-bottom";
			}
		}

		return this.leftCurtainCss_;
	}

	set leftCurtainCss(value: string) {
		this.leftCurtainCss_ = value;
	}

	@computedFrom('rightController.data')
	get rightCurtainCss() {
		//if (this.rightController && this.rightController.data && this.rightController.data.digitalInput1 && this.rightController.data.digitalInput2) {
		if (this.rightController && this.rightController.data) {
			if (1 && this.rightController.data.digitalInput1 === 0 && this.rightController.data.digitalInput2 === 0) {
				this.rightCurtainCss = "right-curtain-middle";
			}

			if (this.rightController.data.digitalInput1 === 1 && this.rightController.data.digitalInput2 === 0) {
				this.rightCurtainCss = "right-curtain-top";
			}

			if (this.rightController.data.digitalInput1 === 0 && this.rightController.data.digitalInput2 === 1) {
				this.rightCurtainCss = "right-curtain-bottom";
			}
		}
		return this.rightCurtainCss_;
	}

	set rightCurtainCss(value: string) {
		this.rightCurtainCss_ = value;
	}


	//@computedFrom('rightController.data')
	//get rightPositionCss(): string {
	//	if (this.rightController.data === undefined) {
	//		return null;
	//	}

	//	if (this.rightController.data.digitalInput1 === 1) {
	//		return "blue";
	//	}

	//	if (this.rightController.data.digitalOutput1 === 1) {
	//		return "red";
	//	}

	//	if (this.rightController.data.digitalInput2 === 1) {
	//		return "green";
	//	}

	//	if (this.rightController.data.digitalOutput2 === 1) {
	//		return "yellow";
	//	}

	//	return "";
	//}
}

